import { usePluginConfig } from '../../contexts/pluginContext';
import WidgetPromotionalAsset from '../atoms/WidgetPromotionalAsset';

const WidgetAd = ({ widgetType, utmSource, utmMedium, utmCampaign, customAdClasses }) => {
  const pluginConfig = usePluginConfig();

  const widgetEvvntAd = (
    <WidgetPromotionalAsset
      widgetType={widgetType}
      utmSource={utmSource}
      utmMedium={utmMedium}
      utmCampaign={utmCampaign}
      customAdClasses={customAdClasses}
    />
  );

  return widgetEvvntAd;
};

export default WidgetAd;
